<template>
  <div class="login">
    <div class="wavy-line"></div>
    <div class="login-box">
      <div class="login-form-box">
        <div class="toggle-btn">
          <div class="toggle_codeimg">
            <img src="../assets/img/login/img_code_background.png" alt="" />
          </div>

          <!-- 微信 -->
          <!--  -->
          <div
            v-show="isPasswordLoginWecaht"
            @click="toggleLoginType(1, false)"
            class="toggle_codeimg_wechat"
          >
            <!-- <img
              @mouseover="mouseinWx"
              @mouseout="mouseoutWx"
              :src="defaultWx"
              alt=""
            /> -->
            <div class="wximg_back"></div>
          </div>
          <div v-show="!isPasswordLoginWecaht" class="toggle_codeimg_wechat">
            <img src="../assets/img/login/icon_weixin_highlight.png" alt="" />
          </div>

          <!-- 返回按钮 -->
          <div v-show="isback" class="toggle_codeimg_back" @click="handleBack">
            <div class="back_img">
              <img src="../assets/img/login/icon_return.svg" alt="" />
            </div>
            <div class="back_span">返回账密登录</div>
          </div>

          <!-- 销讯通 -->

          <div
            v-show="isPasswordLogin"
            @click="toggleLoginType(2, false)"
            class="toggle_codeimg_stp"
          >
            <!-- <img
              @mouseover="mouseinStp"
              @mouseout="mouseoutStp"
              :src="defaultStp"
              alt=""
            /> -->
            <div class="stpimg_back"></div>
          </div>
          <div v-show="!isPasswordLogin" class="toggle_codeimg_stp">
            <img src="../assets/img/login/icon_s2p_highlight.png" alt="" />
          </div>
        </div>

        <!-- 账号登录-->
        <div v-show="!isback">
          <h4 class="login-box_title">账号登录</h4>
          <a-form :form="form" class="login-form" id="loginForm">
            <a-row class="form-row">
              <a-col :span="3" class="item-left">
                <a-icon type="home" class="input-icon" />
              </a-col>
              <a-col :span="21">
                <a-form-item class="form-item">
                  <a-input
                    placeholder="请输入企业代码"
                    class="input-item"
                    v-decorator="['code']"
                  >
                  </a-input>
                </a-form-item>
              </a-col>
            </a-row>

            <a-row class="form-row">
              <a-col :span="3" class="item-left">
                <a-icon type="mobile" class="input-icon" />
              </a-col>
              <a-col :span="21">
                <a-form-item class="form-item">
                  <a-input
                    placeholder="请输入手机号"
                    class="input-item"
                    :maxLength="11"
                    v-decorator="['username']"
                  >
                  </a-input>
                </a-form-item>
              </a-col>
            </a-row>

            <a-row class="form-row">
              <a-col :span="3" class="item-left">
                <a-icon type="lock" class="input-icon" />
              </a-col>
              <a-col :span="21">
                <a-form-item class="form-item">
                  <a-input
                    placeholder="请输入密码"
                    class="input-item"
                    type="password"
                    v-decorator="['password']"
                  >
                  </a-input>
                </a-form-item>
              </a-col>
            </a-row>

            <a-row class="form-row">
              <a-col :span="3" class="item-left">
                <a-icon type="safety-certificate" class="input-icon" />
              </a-col>
              <a-col :span="21">
                <a-col :span="15">
                  <a-form-item class="form-item">
                    <a-input
                      placeholder="请输入验证码"
                      class="input-item"
                      v-decorator="['captcha']"
                    >
                    </a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="9">
                  <a-button
                    type="primary"
                    :disabled="state.smsSendBtn"
                    @click.stop.prevent="getCaptcha"
                    class="sms-button"
                    v-text="
                      (!state.smsSendBtn && '点击获取验证码') ||
                      state.time + ' 秒后重新获取'
                    "
                  ></a-button>
                  <!-- <input type="button" value="点击获取" /> -->
                </a-col>
              </a-col>
            </a-row>
            <div class="box-space">
              <p class="left">
                <router-link :to="{ name: 'AccountActivation' }"
                  >账号激活
                </router-link>
              </p>
              <p>
                <router-link :to="{ name: 'RetrieveThePassword' }"
                  >忘记密码？
                </router-link>
              </p>
            </div>
            <a-form-item>
              <a-button
                type="primary"
                class="login-form-button"
                block
                @click.stop.prevent="onSubmit"
                :disabled="state.submitBtn"
              >
                登录
              </a-button>
            </a-form-item>
          </a-form>
        </div>
        <!--   手机微信扫码登录-->
        <div
          v-if="!isPasswordLoginWecaht"
          class="qrcode-container"
          style="width: 100%"
        >
          <div class="qrcode-correct" id="wechatContainerId">
            <h4 class="login-box_title">微信扫码登录</h4>
            <div class="login-wx-boxes" v-if="wechat_error">
              <!-- 正式版appid   wx41b739f6537ef16b  -->
              <!-- 测试版appid   wxdae6c29420565ede  -->
              <!-- :appid="WxAppId" -->
              <wxlogin
                :appid="WxAppId"
                :scope="'snsapi_login'"
                :theme="'black'"
                :redirect_uri="encodeURIComponent(`${BaseURl}`)"
                rel="external nofollow"
                :state="Math.ceil(Math.random() * 1000)"
                :href="'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsKZGlzcGxheTogbm9uZTsKfQouaW1wb3dlckJveCAucXJjb2RlIHsKYm9yZGVyOiBub25lOwp3aWR0aDogMTUwcHg7CmhlaWdodDogMTUwcHg7Cn0K'"
              >
                <!-- :redirect_uri="encodeURIComponent(`${BaseURl}`)" -->
                <!-- :redirect_uri="
                  encodeURIComponent(
                    'https://s2p.test.s2p.cc/#/scan-code-bindwechat',
                  )
                " -->
              </wxlogin>
            </div>
            <div v-if="!wechat_error">
              <div class="login-boxes_error" @click="RefreshQrcode">
                <img
                  class="qrcode"
                  src="../assets/img/login/img_QRcode_error.png"
                  alt=""
                />
                <div class="qrcode-center">点击刷新二维码</div>
              </div>
              <div class="qrcode-error-footer">二维码已失效，请刷新！</div>
            </div>
            <!-- <div v-if="wechat_error" class="wechat_code">
              打开手机微信，扫描二维码
            </div> -->
          </div>
        </div>

        <!-- 销讯通扫码登录 -->
        <div
          v-show="!isPasswordLogin"
          class="qrcode-container"
          style="width: 100%"
        >
          <div v-if="qrStatus === 1" class="qrcode-correct">
            <h4 class="login-box_title">销讯通扫码登录</h4>
            <div class="login-boxes" v-show="qrImgSrc != ''">
              <img class="qrcode" :src="qrImgSrc" alt="" />
            </div>
            <div v-show="qrImgSrc == ''" class="box-space_loading">
              <a-spin size="large" />
            </div>
            <div class="login-footer">打开手机销讯通，扫描二维码</div>
          </div>
          <div v-if="qrStatus === 2" class="qrcode-success">
            <h4 class="login-box_title">销讯通扫码登录</h4>
            <div class="login-boxes">
              <img
                class="qrcode"
                src="../assets/img/login/img_success_login.png"
                alt=""
              />
            </div>
            <h4 class="login-box_titles">扫描成功!</h4>
            <div>请在APP端确认登录</div>
          </div>
          <div v-if="qrStatus === 3" class="qrcode-error" @click="doQrLogin">
            <h4 class="login-box_title">销讯通扫码登录</h4>
            <div class="login-boxes">
              <img
                class="qrcode"
                src="../assets/img/login/img_QRcode_error.png"
                alt=""
              />
              <div class="qrcode-center">点击刷新二维码</div>
            </div>
            <div class="qrcode-error-footer">二维码已失效，请刷新！</div>
          </div>
          <div v-if="qrStatus === 4" class="qrcode-success qrcode-cancel">
            <h4 class="login-box_title">销讯通扫码登录</h4>
            <div class="login-boxes">
              <img
                class="qrcode"
                src="../assets/img/login/img_QRcode_cancel.jpg"
                alt=""
              />
            </div>
            <h4 class="login-box_titles">APP取消授权!</h4>
            <div @click="doQrLogin" style="cursor: pointer">
              点击重新获取二维码
            </div>
          </div>

          <div v-if="qrStatus === 5" class="qrcode-error" @click="doQrLogin">
            <h4 class="login-box_title">销讯通扫码登录</h4>
            <div class="login-boxes">
              <img
                class="qrcode"
                src="../assets/img/login/img_QRcode_error.png"
                alt=""
              />
              <div class="qrcode-center" style="left: 21%">客户拒绝登录</div>
            </div>
            <div class="qrcode-error-footer">点击刷新二维码</div>
          </div>

          <div v-if="qrStatus === 6" class="qrcode-error" @click="doQrLogin">
            <h4 class="login-box_title">销讯通扫码登录</h4>
            <div class="login-boxes">
              <img
                class="qrcode"
                src="../assets/img/login/img_QRcode_error.png"
                alt=""
              />
              <div class="qrcode-center" style="left: 8%">
                您的登录申请已拒绝
              </div>
            </div>
            <div class="qrcode-error-footer">点击刷新二维码</div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="page-footer"
      v-bind:class="{ collapsed: $store.state.collapsed }"
    >
      Copyright &copy;{{ currentYear }} by 上海正也信息科技有限公司
      <a href="https://beian.miit.gov.cn/" class="beian" target="_blank"
        >沪ICP备14016032号-3</a
      >
    </div>
    <div class="global-loading" v-if="loading">
      <a-spin size="large" tip='登录中' :style="{
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%,-50%)'
      }" />
    </div>
  </div>
</template>

<script>
import * as apiLogin from '@/api/login'
import RegEx from '@/utils/regex'
import { nonEmptyString } from '@/utils/util'
import { loginDetail, loginByCode, getSignInfo } from '@/api/login'
import { getWeiXinScan } from '@/api'
// import {wechatQCode} from 'http://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'
import * as ww from 'jwxwork'
// 组件中引入
import wxlogin from 'vue-wxlogin'

const ERROR_TIP = {
  code: '请输入企业代码',
  username: '请输入手机号',
  password: '请输入密码',
  captcha: '请输入验证码'
}

export default {
  name: 'login',
  components: { wxlogin },
  beforeCreate() {
    this.form = this.$form.createForm(this)
    this.currentYear = new Date().getFullYear()
  },
  data: () => ({
    state: {
      smsSendBtn: false,
      time: 60,
      submitBtn: false
    },
    loading:true,
    isPasswordLogin: true,
    isPasswordLoginWecaht: true,
    qr_data: '',
    // 1-正常，2-成功，3-失败
    qrStatus: 1,
    qrImgSrc: '',
    qrTimer: null,
    timeunixStart: '',
    notConfirmTime: [],
    isPrivatization: false,
    isPrivatizationWechat: false,
    isback: false,
    BaseURl: '',
    WxAppId: '',
    wechat_error: true,
    defaultWx: require('@/assets/img/login/icon_weixin_default.png'),
    defaultStp: require('@/assets/img/login/icon_s2p_default.png')
  }),
  created() {
    var wx = require('weixin-js-sdk')
    window.wx = wx
    if (window.location.href.indexOf('zdjt.com') > -1) {
      console.log(1112222)
      this.isPasswordLogin = false
      this.isPasswordLoginWecaht = false
      // this.isPrivatization = true
      // this.isPrivatizationWechat = true
      this.doQrLogin()
    }
    let domain_name = window.location.href.split('#')[0]
    console.log(this.BaseURl, '8888')
    if (
      window.location.host.indexOf('beta') > -1 ||
      window.location.host.indexOf('test') > -1
    ) {
      this.WxAppId = 'wxdae6c29420565ede'
    } else {
      this.WxAppId = 'wx41b739f6537ef16b'

      if (domain_name.indexOf('www') === -1) {
        let domain_name_arr = domain_name.split('//')
        domain_name =
          domain_name_arr[0] == 'http:'
            ? 'https://www.' + domain_name_arr[1]
            : domain_name_arr[0] + '//www.' + domain_name_arr[1]
      }
    }
    console.log(domain_name)
    this.BaseURl = domain_name + '#/scan-code-bindwechat'
    /*
     * TODO 单点登录
     * */
    if (this.isWeiXin()) {
      this.loading=false;
      return
    }

    if (window.location.href.indexOf('code') > -1) {
      this.loading=true
      let company_id = this.getQueryVariable('state')
      console.log(company_id, 'company_id')
      if (!company_id) {
        let params = window.location.href.split('?')[2]
        let state = params.split('=')[1]
        console.log(state, 'state')
        company_id = state
      }
      let para = {
        js_code: this.getQueryVariable('code'),
        company_id: company_id
      }
      console.log(para)
      loginByCode(para).then((res) => {
        let that=this
        if (0 === res.status) {
          // this.$message.success(res.msg)
          window.location.href = window.location.origin + '/#/home'
          const  interval1 =window.setInterval(() => {
            that.loading=false
            window.clearInterval(interval1)
           }, 1000)
        } else {
          this.loading=false
          this.state.submitBtn = false
          if (res.status !== 5) {
            this.$message.error(res.msg)
          } else {
            let that = this
            this.$confirm({
              title: res.msg,
              content: '',
              onOk() {
                window.sessionStorage.setItem(
                  'loginForm',
                  JSON.stringify(formValues)
                )
                that.$router.push({ name: 'AccountActivation' })
              },
              onCancel() {}
            })
          }
        }
      })
      return
    }

    if (window.location.href.indexOf('state') > -1) {
      let params = window.location.href.split('?')[1]
      let state = params.split('=')[1]
      console.log(state, 'state')

      getSignInfo({
        state
      }).then((res) => {
        if (res.status == 0) {
          let signInfo = res.data.signInfo
          if (signInfo && signInfo.redirect_uri) {
            window.location.href = signInfo.redirect_uri
          }
        }
        console.log(res, '单点登录')
      })
    }else{
      this.loading=false;
    }
    // document.onkeydown = e => {
    //   let _key = window.event.keyCode;
    //   if (_key === 13) {
    //     this.onSubmit();
    //   }
    // };
  },
  // watch: {
  //   $route(to, from, next) {
  //     const that = this
  //     console.log(to, 'toooooooooooooooooooo')
  //     if (to.query.code) {
  //       let parameter = { code: to.query.code }
  //       getWeiXinScan(parameter).then((res) => {
  //         console.log(res, 'resssssssssssssssssss')
  //         if (0 === res.status) {
  //           // 直接登录
  //           this.$router.push({ name: 'home' })
  //           return
  //         } else if (1 === res.status) {
  //           this.$message.error(res.data.errmsg)
  //         } else if (3 === res.status) {
  //           next()
  //           // this.$router.push({ name: 'scanCodeBindWechat' })
  //         } else if (4 === res.status) {
  //           this.$message.error('请重新扫码登录')
  //           this.$router.push({ name: 'login' })
  //         }
  //       })
  //     }
  //   },
  // },

  mounted() {
    this.isPasswordLoginWecaht = this.$route.query.iswechat == 1 ? false : true
    this.isback = this.$route.query.iswechat == 1 ? true : false
  },
  methods: {
    /*
     * // 判断是否为pc端企业微信
     * */
    isWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase()
      if (
        ua.match(/MicroMessenger/i) == 'micromessenger' &&
        ua.match(/wxwork/i) == 'wxwork'
      ) {
        //发送请求向后台获取wx.config信息
        let parameter = {
          url: window.location.href.split('#')[0]
        }
        this.loading=true
        getSignInfo(parameter).then((res) => {
          if (0 === res.status) {
            let signInfo = res.data.signInfo

            this.agentConfig(signInfo)
          } else {
            this.$message.error(res.msg)
          }
          this.loading=false
        })
      } else {
        return false
      }
      return true
    },
    agentConfig(signInfo) {
      if (!window.wx) {
        setTimeout(() => {
          this.agentConfig(signInfo)
        }, 1000)
        return
      }
      window.wx.config({
        debug: false,
        beta: true,
        appId: signInfo.appId,
        timestamp: signInfo.timestamp,
        nonceStr: signInfo.noncestr,
        signature: signInfo.signature,
        jsApiList: ['openDefaultBrowser']
      })
      // 回调
      window.wx.ready(function () {
        window.wx.invoke(
          'openDefaultBrowser',
          {
            // 'url': window.location.href // 在默认浏览器打开redirect_uri，并附加code参数；也可以直接指定要打开的url，此时不会附带上code参数。
            url: signInfo.login_url ? signInfo.login_url : window.location.href
          },
          function (res) {
            console.log(res)
            if (res.err_msg == 'openDefaultBrowser:ok') {
              window.wx.closeWindow()
              close()
            }
          }
        )
      })
    },

    /*
     * 获取链接参数
     * */
    getQueryVariable(variable) {
      var query = window.location.search.substring(1)
      var vars = query.split('&')
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=')
        if (pair[0] == variable) {
          return pair[1]
        }
      }
      return false
    },
    // 发送验证码
    getCaptcha(e) {
      e.preventDefault()
      const that = this
      if (that.state.isSending) {
        return
      }
      const formValues = this.form.getFieldsValue()

      if (!nonEmptyString(formValues.code)) {
        this.$message.error(ERROR_TIP.code)
        return false
      }
      if (!nonEmptyString(formValues.username)) {
        this.$message.error(ERROR_TIP.username)
        return false
      }
      if (RegEx.mobile.test(formValues.username)) {
        that.state.isSending = true
        const interval = window.setInterval(() => {
          that.state.smsSendBtn = true
          if (that.state.time-- <= 0) {
            that.state.time = 60
            that.state.smsSendBtn = false
            that.state.isSending = false
            window.clearInterval(interval)
          }
        }, 1000)

        const hide = that.$message.loading('验证码发送中..', 0)
        apiLogin
          .getSmsCaptcha({
            username: formValues.username,
            code: formValues.code,
            scene: 1
          })
          .then((res) => {
            if (0 === res.status) {
              setTimeout(hide, 2000)
            } else {
              this.$message.error(res.msg)
              setTimeout(hide, 1)
              window.clearInterval(interval)
              that.state.time = 60
              that.state.smsSendBtn = false
              that.state.isSending = false
            }
          })
          .catch((err) => {
            setTimeout(hide, 1)
            window.clearInterval(interval)
            that.state.time = 60
            that.state.smsSendBtn = false
            this.requestFailed(err)
            that.state.isSending = false
          })
      } else {
        that.$message.error('手机号格式错误')
      }
    },
    onSubmit() {
      const formValues = this.form.getFieldsValue()
      for (let key in formValues) {
        if (!nonEmptyString(formValues[key])) {
          this.$message.error(ERROR_TIP[key])
          return false
        } else if (
          key === 'username' &&
          !RegEx.mobile.test(formValues.username)
        ) {
          this.$message.error('手机号格式错误')
          return false
        }
      }
      this.state.submitBtn = true
      apiLogin
        .login({
          username: formValues.username,
          password: formValues.password,
          code: formValues.code,
          captcha: formValues.captcha
        })
        .then((res) => {
          if (0 === res.status) {
            // this.state.submitBtn = false;
            let paramers = {}
            loginDetail(paramers).then((res) => {
              let that = this
              if (9 === res.status) {
                new Vue().$info({
                  title: '提示',
                  content: res.msg,
                  onOk() {
                    that.state.submitBtn = false
                  }
                })
              } else {
                this.$router.push({ name: 'home' })
              }
            })
          } else {
            this.state.submitBtn = false
            if (res.status !== 5) {
              this.$message.error(res.msg)
            } else {
              let that = this
              this.$confirm({
                title: res.msg,
                content: '',
                onOk() {
                  window.sessionStorage.setItem(
                    'loginForm',
                    JSON.stringify(formValues)
                  )
                  that.$router.push({ name: 'AccountActivation' })
                },
                onCancel() {}
              })
            }
          }
        })
        .catch((err) => {
          this.requestFailed(err)
        })
    },
    requestFailed(err) {
      const errMsg =
        (err.data && err.data.msg) || err.msg || '请求出现错误，请稍后再试'
      this.$message.error(errMsg)
      this.state.submitBtn = false
    },
    clearQRtimer() {
      clearInterval(this.qrTimer)
      this.qrTimer = null
    },
    doQrLogin() {
      // 缓存一下this，留在计时器中使用
      let that = this

      // 清空旧二维码图片
      this.qrImgSrc = ''

      // 关闭清空计时器
      this.clearQRtimer()

      // 显示二维码扫码状态页面
      this.qrStatus = 1

      // 请求新的二维码内容qr_data
      apiLogin
        .scanQrLogin({
          qr_data: ''
        })
        .then((res) => {
          // console.log(res.status);
          // console.log(res.data.qr_data);
          this.notConfirmTime = []
          // 获取二维码内容成功
          if (2 == res.status) {
            this.qr_data = res.data.qr_data
            this.qrImgSrc =
              this.$axios.defaults.baseURL +
              'jurisdiction/website/login/qrcode?qr_data=' +
              this.qr_data
            this.timeunixStart = new Date().valueOf()

            // 启动计时器，轮询移动端处理状态
            this.qrTimer = setInterval(() => {
              apiLogin
                .scanQrLogin({
                  qr_data: that.qr_data
                })
                .then((res) => {
                  // res.status = 12;
                  // 状态4，移动端未操作
                  if (4 == res.status) {
                    // 5分钟没有扫码，二维码过期
                    if (
                      new Date().valueOf() - this.timeunixStart >
                      1000 * 60 * 5
                    ) {
                      that.clearQRtimer()
                      that.qrImgSrc = ''
                      that.qrStatus = 3
                    }
                    return
                  }

                  // 状态1，移动端二维码错误，显示刷新页面
                  if (1 == res.status) {
                    that.clearQRtimer()
                    that.qrImgSrc = ''
                    that.qrStatus = 3
                    return
                  }
                  // 扫码成功，未确认
                  if (5 == res.status) {
                    that.notConfirmTime.push(new Date().valueOf())
                    // 5分钟没有扫码，二维码过期
                    if (
                      new Date().valueOf() - that.notConfirmTime[0] >
                      1000 * 60 * 2
                    ) {
                      that.clearQRtimer()
                      that.qrImgSrc = ''
                      that.qrStatus = 3
                      return
                    }
                    that.qrImgSrc = ''
                    that.qrStatus = 2
                  }
                  // 扫码成功，app取消登录
                  if (6 == res.status) {
                    that.clearQRtimer()
                    that.qrImgSrc = ''
                    that.qrStatus = 4
                    return
                  }
                  // 扫码成功，app取消登录
                  if (11 == res.status) {
                    that.clearQRtimer()
                    that.qrImgSrc = ''
                    that.qrStatus = 5
                    return
                  }
                  // 扫码成功，协助人员拒绝
                  if (13 == res.status) {
                    that.clearQRtimer()
                    that.qrImgSrc = ''
                    that.qrStatus = 6
                    return
                  }
                  // 状态0，移动端二维码确认登录成功，首页跳转
                  if (0 == res.status) {
                    that.clearQRtimer()
                    // 扫码成功跳转到首页
                    that.$router.push({ name: 'home' })
                    return
                  }
                })
            }, 5000)
          }
        })
    },
    toggleLoginType(e, boolean) {
      console.log(e, 'eeeeeeeeee')
      if (e == 1) {
        this.defaultWx = require('@/assets/img/login/icon_weixin_highlight.png')
        this.isPasswordLoginWecaht = boolean
        this.isPasswordLogin = !boolean
        this.isback = !boolean
        this.clearQRtimer()
        this.wechat_error = true
        setTimeout(() => {
          this.wechat_error = !this.wechat_error
        }, 1000 * 5 * 60)
      } else if (e == 2) {
        this.defaultStp = require('@/assets/img/login/icon_s2p_highlight.png')
        this.isPasswordLogin = boolean
        this.isPasswordLoginWecaht = !boolean
        this.isback = !boolean
        if (!this.isPasswordLogin) {
          this.doQrLogin()
        } else {
          this.clearQRtimer()
        }
      }
    },
    RefreshQrcode() {
      this.wechat_error = !this.wechat_error
      this.$forceUpdate()
      setTimeout(() => {
        this.wechat_error = !this.wechat_error
      }, 1000 * 5 * 60)
    },
    handleBack() {
      this.isback = false
      this.isPasswordLogin = true
      this.isPasswordLoginWecaht = true
    },
    mouseinWx() {
      this.defaultWx = require('@/assets/img/login/icon_weixin_highlight.png')
    },
    mouseoutWx() {
      this.defaultWx = require('@/assets/img/login/icon_weixin_default.png')
    },
    mouseinStp() {
      this.defaultStp = require('@/assets/img/login/icon_s2p_highlight.png')
    },
    mouseoutStp() {
      this.defaultStp = require('@/assets/img/login/icon_s2p_default.png')
    }
  },
  //销毁定时器
  destroyed() {
    this.clearQRtimer()
  }
}
</script>

<style lang="less" scoped>
.login {
  position: relative;
  width: 100%;
  height: 100%;
  background: url('~@/assets/img/login/img_background.png') repeat-x;
  background-size: auto 100%;

  .wavy-line {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 236px;
    background: url('~@/assets/img/login/img_wavy_line.png') no-repeat;
    background-size: 100% 100%;
  }

  .login-box {
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 46px;
    width: 1092px;
    height: 624px;
    transform: translate(-50%, -50%);
    background: url('~@/assets/img/login/img_login_box.png') no-repeat;
    background-size: 100% 100%;

    .login-box_title {
      margin-bottom: 50px;
      text-align: center;
      font-size: 24px;
      color: #008fff;
      font-weight: 400;
    }

    .login-box_titles {
      margin-top: 50px;
      text-align: center;
      font-size: 24px;
      color: #008fff;
      font-weight: 400;
    }

    .login-form-box {
      float: right;
      padding: 80px 78px 10px 78px;
      width: 50%;
      height: 100%;
      position: relative;
      display: flex;
      justify-content: center;

      .login-form {
        .form-row {
          position: relative;
          margin-bottom: 10px;
          padding: 0 0 6px 0;
          height: 45px;

          &::after {
            position: absolute;
            content: '';
            bottom: 0;
            left: 0;
            width: 100%;
            height: 2px;
            background: #dfdfdf;
            transform: scale(1, 0.4);
          }

          .form-item {
            margin-bottom: 0;
          }

          .item-left {
            position: relative;
            height: 38px;

            &::after {
              position: absolute;
              content: '';
              right: 0;
              top: 50%;
              transform: translate(0, -50%);
              height: 16px;
              width: 1px;
              background: #dfdfdf;
            }
          }

          .input-icon {
            position: absolute;
            top: 10px;
            left: 10px;
            font-size: 20px;
            color: #9a9a9a;
            z-index: 1;
          }

          .input-item {
            padding-left: 16px;
            border: 0 none;
            font-size: 16px;
            outline: 0 none;

            &:focus {
              outline: none;
              border: 0 none;
              box-shadow: none;
            }
          }
        }

        .login-form-button {
          margin-top: 20px;
          height: 40px;
        }

        .sms-button {
          margin-top: 3px;
          padding: 0 10px;
          font-size: 12px;
        }
      }

      .toggle-btn {
        position: absolute;
        right: 0;
        top: 0;
        width: 80px;
        height: 80px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        .toggle_codeimg {
          width: 100px;
          height: 100px;
          position: absolute;
          left: -25px;
          top: 2px;

          img {
            width: 100%;
            height: 100%;
          }
        }
        .toggle_codeimg_wechat {
          width: 30px;
          height: 30px;
          position: absolute;
          left: 40px;
          top: 33px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .toggle_codeimg_back {
          width: 155px;
          position: absolute;
          top: 17px;
          right: 331px;
          display: flex;
          .back_img {
            width: 25px;
            height: 25px;
            line-height: 25px;
            img {
              width: 100%;
              height: 100%;
              line-height: 25px;
            }
          }
          .back_span {
            color: #579cfb;
            font-size: 20px;
            margin-left: 10px;
          }
        }
        .toggle_codeimg_stp {
          width: 30px;
          height: 30px;
          position: absolute;
          left: 11px;
          top: 8px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  @media screen and (-webkit-min-device-pixel-ratio: 2),
    screen and (max--moz-device-pixel-ratio: 2) {
    .login-box {
      background: url('~@/assets/img/login/img_login_box@2x.png') no-repeat;
      background-size: 100% 100%;
    }
  }
}

.page-footer {
  position: fixed;
  bottom: 5px;
  left: 0;
  width: 100%;
  text-align: center;
  height: 16px;
  color: #fff;
  font-size: 11px;

  .beian {
    color: #fff;
  }
}

.box-space {
  margin-bottom: 0;

  p {
    display: inline-block;
    width: 49%;
    text-align: right;

    &.left {
      text-align: left;
    }
  }

  a {
    font-size: 12px;
  }
}

.qrcode-container {
  position: relation;

  .qrcode-correct {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .login-boxes {
      position: relative;
      width: 150px;
      height: 150px;

      .qrcode {
        width: 100%;
        height: 100%;
      }
    }

    .login-footer {
      margin-top: 40px;
      color: black;
    }
  }

  .qrcode-success {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .login-boxes {
      position: relative;
      width: 150px;
      height: 150px;

      .qrcode {
        width: 100%;
        height: 100%;
      }
    }

    div {
      color: black;
    }
  }

  .qrcode-error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    .login-boxes {
      position: relative;
      width: 150px;
      height: 150px;
      border: 1px solid #cdcdcd;
      padding: 10px;

      .qrcode {
        width: 100%;
        height: 100%;
      }

      .qrcode-center {
        position: absolute;
        top: 43%;
        left: 16%;
      }
    }

    .qrcode-error-footer {
      margin-top: 40px;
    }
  }

  .qrcode-cancel {
    .login-box_titles {
      color: #bf443d;
    }
  }
}

.box-space_loading {
  text-align: center;
  padding: 55px 0;
}
.login-boxes_error {
  position: relative;
  width: 150px;
  height: 150px;
  cursor: pointer;

  .qrcode {
    width: 100%;
    height: 100%;
  }
  .qrcode-center {
    position: absolute;
    top: 43%;
    left: 16%;
  }
}
.qrcode-error-footer {
  margin-top: 40px;
}
.wechat_code {
  position: relative;
  top: -100px;
  left: 6px;
  color: #b2b2b2;
}
.wximg_back {
  width: 30px;
  height: 30px;
  background: url('../assets/img/login/icon_weixin_default.png') no-repeat !important;
  background-size: 100% 100% !important;
}
.wximg_back:hover {
  width: 30px;
  height: 30px;
  background: url('../assets/img/login/icon_weixin_highlight.png') no-repeat !important;
  background-size: 100% 100% !important;
}
.stpimg_back {
  width: 30px;
  height: 30px;
  background: url('../assets/img/login/icon_s2p_default.png') no-repeat !important;
  background-size: 100% 100% !important;
}
.stpimg_back:hover {
  width: 30px;
  height: 30px;
  background: url('../assets/img/login/icon_s2p_highlight.png') no-repeat !important;
  background-size: 100% 100% !important;
}

.global-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000000;
  background: #f0f2f5;
}
</style>
